import React from 'react';
import TbTruckDelivery from '../icons/TbTruckDelivery';

import '../styles/FreeShippingBlock.css';
import { bool, string } from 'prop-types';

export default function FreeShippingBlock({ heading = '', text = '', isMobile }) {
    return (<div
        className={'free-shipping-block'}>
        <TbTruckDelivery
            className={'free-shipping-block--icon'}
            size={!isMobile ? '50px' : '40px'} />
        <div
            className={'free-shipping-block--inner'}>
            <span>{heading}</span>
            <p>{text}</p>
        </div>
    </div>);
}

FreeShippingBlock.propTypes = {
    heading: string,
    text: string,
    isMobile: bool,
};